<template>
  <aside class="main-panel__sidebar">
    <section class="sidebar-profile-container">
      <user-card-component></user-card-component>
    </section>
    <section>
      <div class="sidebar-wallet" style="min-height: 100px">
        <profile-balance-component></profile-balance-component>
      </div>
    </section>

    <section>
      <div class="sidebar-matches" style="min-height: 250px">
        <online-card-component></online-card-component>
      </div>
    </section>
  </aside>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'SideBarComponent',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {},
  mounted() {
  }
};
</script>
